import { PricingOptionType } from '@/types/cart';

export interface SubscriptionSignal {
    pricingOptionType?: PricingOptionType | null;
    pricingOptionLabel?: string | null;
    isSubscription?: boolean | null;
    subscriptionMonths?: number | null;
    subscriptionMonthlyRate?: number | null;
}

export const isSubscriptionCartItem = (item: SubscriptionSignal): boolean => {
    if (item.pricingOptionType === PricingOptionType.MonthlySubscription) {
        return true;
    }

    if (item.isSubscription === true) {
        return true;
    }

    if (item.subscriptionMonths !== undefined && item.subscriptionMonths !== null) {
        return true;
    }

    if (item.subscriptionMonthlyRate !== undefined && item.subscriptionMonthlyRate !== null) {
        return true;
    }

    if (item.pricingOptionLabel?.toLowerCase().includes('subscription')) {
        return true;
    }

    return false;
};

export const isRentalCartItem = (item: SubscriptionSignal): boolean =>
    !isSubscriptionCartItem(item);

